import { useLocation } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import PaymentMethod from "./Components/PaymentMethod";
import { useChallenge } from "../../context/ChallengeContext";

export default function PaymentMethodPage() {
  const location = useLocation();
  const { defaultPlanName, getPlanByName } = useChallenge();
  const planFromState = location.state?.plan;
  const planNameFromState =
    location.state?.planName ?? planFromState?.planName ?? defaultPlanName;
  const selectedPlan =
    planFromState ?? getPlanByName(planNameFromState ?? defaultPlanName);
  const payablePrice =
    location.state?.payablePrice ??
    selectedPlan?.discountPrice ??
    selectedPlan?.price ??
    "";
  const payablePriceIrr =
    location.state?.payablePriceIrr ??
    selectedPlan?.discountPriceIrr ??
    selectedPlan?.priceIrr ??
    "";

  return (
    <LayoutPage
      activeIndex={2}
      navItems={["خرید چالش جدید", "انتخاب چالش", "روش پرداخت"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-hidden"
    >
      <PaymentMethod
        plan={selectedPlan}
        payablePrice={payablePrice}
        payablePriceIrr={payablePriceIrr}
      />
    </LayoutPage>
  );
}
